module.exports = __webpack_public_path__ + "static/Lunchtype22-Medium-bcc9448470df6c2ad6e8087651d53141.ttf";